import { render, staticRenderFns } from "./BBookingLocalizator.vue?vue&type=template&id=b0cfbf12&scoped=true&"
import script from "./BBookingLocalizator.vue?vue&type=script&lang=js&"
export * from "./BBookingLocalizator.vue?vue&type=script&lang=js&"
import style0 from "./BBookingLocalizator.vue?vue&type=style&index=0&id=b0cfbf12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cfbf12",
  null
  
)

export default component.exports